'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = refCount;

var _registry = require('../actions/registry');

function refCount() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var action = arguments[1];

	switch (action.type) {
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
			return state + 1;
		case _registry.REMOVE_SOURCE:
		case _registry.REMOVE_TARGET:
			return state - 1;
		default:
			return state;
	}
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dnd-core/lib/reducers/refCount.js
 ** module id = 935
 ** module chunks = 0
 **/